import { useMutation } from '~/utils/rq';

type GeneratedAnswersResponse = {
  items: string[];
};

type useMutateGeneratedAnswersProps = {
  campaignId?: string;
  kpiType?: string;
};

export const useMutateGeneratedAnswers = ({
  campaignId,
  kpiType
}: useMutateGeneratedAnswersProps) => {
  const URL = `campaigns/${campaignId}/template-questions/generate-answers/${kpiType}`;

  return useMutation<unknown, GeneratedAnswersResponse>(
    {},
    {
      url: URL,
      method: 'get'
    }
  );
};
